import {useMemo} from 'react';

import {useAccountContext} from '../contexts/AccountContext';
import {getContactValidationIssues} from '../components/KeyClientDataBanner/KeyClientDataBanner';
import {useReviewContext} from '../contexts/ReviewContext';

export const useClientDataValidation = () => {
  const {validationContacts} = useAccountContext();
  const clientDataIssues = useMemo(
    () => getContactValidationIssues(validationContacts ?? []),
    [validationContacts]
  );
  const hasClientDataIssues = clientDataIssues.length > 0;
  return {clientDataIssues, hasClientDataIssues};
};

export const useReviewDataValidation = () => {
  const {reviewDetails} = useReviewContext();
  const reviewDataIssues = useMemo(
    () => getContactValidationIssues(reviewDetails?.validationContacts ?? []),
    [reviewDetails?.validationContacts]
  );
  const hasReviewDataIssues = reviewDataIssues.length > 0;
  return {reviewDataIssues, hasReviewDataIssues};
};
